import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTASection() {
  return <SectionWrapper bgColor="sand" className="text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto py-10 space-y-8" data-id="element-56">
        <p className="text-xl md:text-2xl text-text-secondary leading-relaxed" data-id="element-57">
          Podés seguir reaccionando o podés empezar a regularte.
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl text-text leading-tight" data-id="element-58">
          Te devuelve el control sobre tu estado interno
        </h2>
        <div className="pt-2" data-id="element-59">
          <CTAButton className="text-lg px-10 py-5" data-id="element-60">
            Quiero recuperar mi eje
          </CTAButton>
        </div>
      </div>
    </SectionWrapper>;
}